export const ClearStringNumber = value => {
  return value.replace(/\D/g, '')
}
